export default [
    {
        // header: 'Historie',
        icon: 'GridIcon',
        route: '7-tage',
        title: '7 Tage +'
    },
]
